import api from './api'

let currentCurrency = 'USD'

export const getPricing = (coupon) => {
  return new Promise((resolve, reject) => {
    const currency = currentCurrency

    const endpoint = coupon
      ? `v2/pricing/verify_coupon/${coupon}`
      : 'v2/pricing/products/web'

    api('GET', `${endpoint}?currency=${currency}`)
      .then((answer) => {
        const {
          currency,
          available_currencies: availableCurrencies = [],
          name: currencyName,
          discount = null,
          trial_duration: trialDuration = 0,
          discount_type: discountType = '%',
          discount_only_first_purchase: discountOnlyFirstPurchase,
        } = answer.response

        const products = answer.response.products
          .sort((a, b) => a.duration - b.duration)
          .map((plan) => ({
            ...plan,
            currency,
            currencyName,
            discount,
            discountType,
          }))

        const pricing = {
          coupon,
          products,
          currency,
          currencyName,
          availableCurrencies: availableCurrencies.filter(
            (currency) => currency !== 'EURO',
          ),
          discount,
          discountOnlyFirstPurchase,
          trialDuration,
          discountType,
        }

        resolve(pricing)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const verifyCoupon = (coupon) =>
  new Promise((resolve, reject) => {
    api('GET', `v2/pricing/verify_coupon/${coupon}`)
      .then(() => resolve())
      .catch((err) => reject(err))
  })

export function setCurrency(currency) {
  currentCurrency = currency
}
